import { ApiResource } from "./apiResource";
import { format } from "date-fns";
import {
  ApiEmptyResponse,
  ApiDataResponse,
  PaginationResponse,
} from "../apiClient";
import {
  LinkedChannelType,
  ExternalRequestResponseType,
} from "~/type/linkedChannelType";
import {
  SessionStatus,
  SessionCategory,
  SessionType,
} from "~/constant/session";

// history: 차팅이력, encounter: 내원정보
export enum SessionsHistoriesType {
  history = "history",
  encounter = "encounter",
}

interface SessionStatsParams {
  startAt: string;
  endAt: string;
  departmentIds?: string;
  statusIds?: string;
}

interface SessionStatsData {
  new: number;
  total: number;
  established: number;
  canceled: number;
  appointment: number;
  today: number;
}

export interface TreatmentItemData {
  categoryName: string;
  name: string;
}

export interface ChartsData {
  id: number;
  memo: string;
  items: TreatmentItemData & { count: number }[];
  type:
    | "CONSULTING"
    | "TREATMENT"
    | "SURGERY"
    | "NURSE_OPERATION"
    | "NURSE_CARE"
    | "SKINCARE"
    | "PAYMENT";
}

export interface SessionsHistoriesRawData {
  acquisitionChannelName: null | string;
  appointment: null | {
    acquisitionChannelName: null | string;
    assistName: null | string;
    category: SessionCategory;
    counselorName: null | string;
    date: string;
    doctorName: null | string;
    externalLinkedChannel: null | LinkedChannelType;
    id: number;
    isDeleted: boolean;
    memo: null | string;
    status: string;
    treatmentItems: TreatmentItemData[];
  };
  assistName: null | string;
  category: SessionCategory;
  charts: ChartsData[];
  counselorName: null | string;
  date: string;
  departmentName: string;
  doctorName: null | string;
  endHour: string;
  externalLinkedChannel: null | LinkedChannelType;
  externalRequestStatus: null | ExternalRequestResponseType;
  id: number;
  memo: null | string;
  startHour: string;
  status: SessionStatus;
  statusCode: SessionStatus;
  statusColor: string;
  statusName: string;
  treatmentItems: TreatmentItemData[];
  type: SessionType;
}

export class SessionApi extends ApiResource {
  async getStatusSettings() {
    return this.client.get<ApiDataResponse<any>>(
      `/sessions/session_status_config`
    );
  }

  async getSessionsSimple(params: any) {
    return this.client.get<PaginationResponse<any>>(`/sessions/simple`, {
      params,
    });
  }

  async getSessions(params: any) {
    return this.client.get<ApiDataResponse<any>>(`/sessions`, { params });
  }

  async getRawSessionsHistories(params: {
    customerId: number;
    dataType: SessionsHistoriesType;
    page?: number;
    limit?: number;
    orderBy?: string;
    departmentIds?: string;
  }) {
    return this.client.get<PaginationResponse<SessionsHistoriesRawData[]>>(
      "/sessions/raw/histories",
      { params }
    );
  }

  async getSessionsHistories(params: any) {
    return this.client.get<PaginationResponse<any>>(`/sessions/histories`, {
      params,
    });
  }

  async cancelSessions(id: string | number, params?: any) {
    return this.client.post<ApiEmptyResponse>(`/sessions/${id}/cancel`, params);
  }

  async getAppointmentsCount(params: SessionStatsParams) {
    return this.client.get<ApiDataResponse<SessionStatsData>>(
      `/sessions/raw/stats`,
      { params }
    );
  }

  async getAppointmentsTime(date = new Date(), departmentId: string) {
    return this.client.get<ApiDataResponse<any>>(`/sessions/occupations`, {
      params: {
        date: format(new Date(date), "yyyy-MM-dd"),
        departmentId,
      },
    });
  }
}
